import axios from 'axios'
import api from './index'
import {maindomain} from '../util/init'
import store from '../store/store'
import {clearCookie} from '../util/celecookie'
/**
 *
 * @type {{}}
 */
axios.defaults.timeout = 60000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charest=utf-8'
axios.interceptors.request.use(config => {
  // 判断是否有cmpycode
  // const cmpycode = getCookie('cmpycode');
  // if (cmpycode) {
  //   config.headers = {'AccessToken': cmpycode} // 后台接收的参数，后面我们将说明后台如何接收
  // } else {
  //   store.state.dispatch('CmpyinfoByReqdomain', reqDomainparams)
  // }
  return config
}, err => {
  return Promise.reject(err)
})
axios.interceptors.response.use(response => {
  if (response.data.status == '008') {
      clearCookie()
     window.location.reload()
  }
    if (response.data.status == '778') {
    let href = encodeURIComponent(window.location.href)
    window.location.href = `${store.state.common.prefixAgreement}://${maindomain()}/login/?hrefs=${href}`
    clearCookie()
  }
  return response
}, err => {
  return Promise.reject(err)
})

//线上
let base = '/mall'  
//线下 
//let base = '/apis/mall'
let basesy = '/api/trace/query/codes'

export default {
  GET_CODETYPEINFO: basesy + '/codeTypeInfo',
  GET_BASEINFO: basesy + '/baseInfo',
  GET_RHISTORIES: basesy + '/rhistories',
  GET_MODULEINFO: basesy + '/moduleInfo',
  GET_MODULEINFOBYQYDM: basesy + '/moduleInfoByQydm',
  GET_ALLMODULEINFOBYQYDM: basesy + '/getAllModuleInfoByQydm',
  GET_WEATHERINFO: '/api/weather/getNowWithCath',
  //  根据域名初始访问的企业 
  GET_CMPYINFOBYREQDOMAIN (params) {
    return api.fetch('post', `${base}/getCmpyinfoByReqdomain`, params)
  },
  // 获取企业的基础营销配置信息
  GET_SYSMARINFO (params) {
    return api.fetch('post', `${base}/getSysmarinfo`, params)
  },
   // 3.1.3.获取企业的订单和发货配置信息接口
   GET_PUBORDPRINTINFO (params) {
    return api.fetch('post', `${base}/getPubordprintinfo`, params)
  },
  // 账号登录接口
  GET_LOGINBYACCOUNTN (params) {
    return api.fetch('post', `${base}/loginByAccount`, params)
  },
  // 账号注册接口
  GET_REGISTERBYACCOUNT (params) {
    return api.fetch('post', `${base}/registerByAccount`, params)
  },
   // 账号退出
   GET_LOGINOUT (params) {
      return api.fetch('post', `${base}/loginOut`, params)
    },
  // 密码找回发送手机验证码接口（密码找回）
  GET_CHECKCODETOFINDPWD (params) {
    return api.fetch('post', `${base}/getCheckcodeToFindPwd`, params)
  },
  // 重设密码接口（密码找回）
  GET_UPDATEPWD (params) {
    return api.fetch('post', `${base}/updatePwd`, params)
  },
  // 账号安全级别校验接口
  GET_CHECKACCOUNTSECURITYLEVEL (params) {
    return api.fetch('post', `${base}/checkAccountSecurityLevel`, params)
  },
  // 验证码有效性确认接口（密码找回）
  GET_CHECKVALCHECKCOD (params) {
    return api.fetch('post', `${base}/checkValCheckcode`, params)
  },
  // 注册/绑定发送验证码接口
  GET_CHECKCODETOREGISTER (params) {
    return api.fetch('post', `${base}/getCheckcodeToRegister`, params)
    // return api.fetch('post', `${base}/getToRegister`, params)
  },
  // 确认账号有效性接口（密码找回）
  GET_CHECKACCOUNTVAL (params) {
    return api.fetch('post', `${base}/checkAccountVal`, params)
  },
  //  微信登录/注册初始化接口
  GET_LOGINORREGISTERINITBYWX (params) {
    // return api.fetch('post', `${base}/loginOrRegisterInitByWX`, params)
    return api.fetch('post', `${base}/initByWX`, params)
  },
  // GET_INITBYWX (params) {
  //   return api.fetch('post', `${base}/InitByWX`, params)
  // },
  // 微信登录/注册接口
  GET_LOGINORREGISTERBYWX (params) {
    return api.fetch('post', `${base}/loginOrRegisterByWX`, params)
  },
  // 手机号码/邮箱确认绑定接口
  GET_BINDMPHONE (params) {
    return api.fetch('post', `${base}/bindMphone`, params)
  },
  // 获取会员信息详情
  GET_GETMEMBERINFO (params) {
    return api.fetch('post', `${base}/getMemberinfo`, params)
  },
  // 已登录用户发送验证码接口
  GET_GETCHECKCODEBYLOGINEDMEMBERINFO (params) {
    return api.fetch('post', `${base}/getCheckcodeByLoginedMemberinfo`, params)
  },
  // 已登录用户验证码有效性接口
  GET_CHECKVALCHECKCODEBYLOGINEDMEMBERINFO (params) {
    return api.fetch('post', `${base}/checkValCheckcodeByLoginedMemberinfo`, params)
  },
  // 已登录用户密码修改接口
  GET_UPDATEPWDBYLOGINEDMEMBERINFO (params) {
    return api.fetch('post', `${base}/updatePwdByLoginedMemberinfo`, params)
  },
  // 已登录用户微信绑定接口
  GET_BINDBYWX (params) {
    return api.fetch('post', `${base}/bindByWX`, params)
  },
  // 已登录用户微信绑定取消接口
  GET_UNBINDBYWX (params) {
    return api.fetch('post', `${base}/unbindByWX`, params)
  },
  // 获取banner数据接口
  GET_BANNERLIST (params) {
    return api.fetch('post', `${base}/getBannerList`, params)
  },
  // 获取公告数据接口
  GET_BBS (params) {
    return api.fetch('post', `${base}/getBbs`, params)
  },
  // 获取全国门店数据接口
  GET_STORELIST (params) {
    return api.fetch('post', `${base}/getStoreList`, params)
  },
  // 修改个人信息 updateBaseMemberinfo
  GET_UPDATEBASEMEMBERINFO (params) {
    return api.fetch('post', `${base}/updateBaseMemberinfo`, params)
  },
  // 消费者意见建议提交
  GET_ADDSUGGESTIONS (params) {
    return api.fetch('post', `${base}/addSuggestions`, params)
  },
  // 消费者理赔申请提交
  GET_ADDRETURNAPPLICATION (params) {
    return api.fetch('post', `${base}/addReturnapplication`, params)
  },
  // 获取企业基础信息
  GET_BASICCMPYINFO (params) {
    return api.fetch('post', `${base}/getBasiccmpyinfo`, params)
  },
  // 新增提问记录
  GET_ADDFAQ (params) {
    return api.fetch('post', `${base}/addFaq`, params)
  },
  // 获取常见问题/提问记录列表
  GET_FAQLIST (params) {
    return api.fetch('post', `${base}/getFaqList`, params)
  },
  // 省市区三级联动查询接口getAddrinfo
  GET_ADDRINFO (params) {
    return api.fetch('post', `${base}/getAddrinfo`, params)
  },
  //  收货人信息列表查询接口
  GET_ADDRLIST (params) {
    return api.fetch('post', `${base}/getAddrList`, params)
  },
  // 收货人信息详情查询接口
  GET_ADDRDET (params) {
    return api.fetch('post', `${base}/getAddrDet`, params)
  },
  // 收货人信息删除接口
  GET_DELETEADDR (params) {
    return api.fetch('post', `${base}/deleteAddr`, params)
  },
  // 收货人信息新增接口
  GET_ADDADDR (params) {
    return api.fetch('post', `${base}/addAddr`, params)
  },
// 收货人信息更新接口
  GET_UPDATEADDR (params) {
    return api.fetch('post', `${base}/updateAddr`, params)
  },
  // 更新指定收货人信息为默认地址
  GET_UPDATEADDRISDEF (params) {
    return api.fetch('post', `${base}/updateAddrIsDef`, params)
  },
  // 获取商品推荐列表
  GET_GOODSLISTFORHOT (params) {
    return api.fetch('post', `${base}/getGoodsListForHot`, params)
  },
  // 获取我的足迹列表
  GET_BROWSEINFOLIST (params) {
    return api.fetch('post', `${base}/getBrowseinfoList`, params)
  },
  // 添加常规商品浏览足迹
  GET_ADDBROWSEINFO (params) {
    return api.fetch('post', `${base}/addBrowseinfo`, params)
  },
  GET_GOODSLISTFORRECOMMEND (params) {
    return api.fetch('post', `${base}/getGoodsListForRecommend`, params)
  },
  GET_GOODSLISTFORSECKILL (params) {
    return api.fetch('post', `${base}/getGoodsListForSeckill`, params)
  },
  GET_GOODSLISTFORPUSH (params) {
    return api.fetch('post', `${base}/getGoodsListForPush`, params)
  },
  GET_THEMEINFOLIST (params) {
    return api.fetch('post', `${base}/getThemeinfoList`, params)
  },
  GET_GOODSLISTFOREXPRESALE (params) {
    return api.fetch('post', `${base}/getGoodsListForExpresale`, params)
  },
  GET_SEARCHKEYWORDS (params) {
    return api.fetch('post', `${base}/getSearchKeywords`, params)
  },
  GET_CLASSIFYLIST (params) {
    return api.fetch('post', `${base}/getClassifyList`, params)
  },
  GET_GOODSLIST (params) {
    return api.fetch('post', `${base}/getGoodsList`, params)
  },
  GET_ADDRESS (params) {
    return api.fetch('post', `${base}/getAddrinfo`, params)
  },
  // 获取商品信息详情
  GET_GOODSINFODET (params) {
    return api.fetch('post', `${base}/getGoodsinfoDet`, params)
  },
  // 获取商品参加的促销活动
  GET_GOODSPROMOTIONS (params) {
    return api.fetch('post', `${base}/getGoodsPromotions`, params)
  },
  // 获取商品指定规格库存
  GET_GOODSINVINFO (params) {
    return api.fetch('post', `${base}/getGoodsinvinfo`, params)
  },
  // 获取商品描述详情
  GET_GOODSDESC (params) {
    return api.fetch('post', `${base}/getGoodsDesc`, params)
  },
  // 我的常购商品列表,包括实物商品、兑换礼券、充值卡
  GET_OFTENBUYGOODSLIST (params) {
    return api.fetch('post', `${base}/getOftenbuygoodsList`, params)
  },
  // 我的资产
  // 账户余额获取接口
  GET_ACCOUNTBALANCE (params) {
    return api.fetch('post', `${base}/getAccountBalance`, params)
  },
// 可用券卡数量统计接口
  GET_STATISTICALBYCARD (params) {
    return api.fetch('post', `${base}/getStatisticalByCard`, params)
  },
// 资产变更明细
  GET_MARDETAIL (params) {
    return api.fetch('post', `${base}/getMardetail`, params)
  },
// 资产指定区间明细统计
  GET_STATISTICALBYMARDETAIL (params) {
    return api.fetch('post', `${base}/getStatisticalByMardetail`, params)
  },
// 充值卡充值接口
  GET_ADDCARDTORECHARGE (params) {
    return api.fetch('post', `${base}/addCardToRecharge`, params)
  },
// 我的卡包
  GET_CARDBAG (params) {
    return api.fetch('post', `${base}/getCardbag`, params)
  },
// 查询券卡多选专区详情
  GET_OPTGOODSINFOOFCODE (params) {
    return api.fetch('post', `${base}/getOptgoodsinfoOfCode`, params)
  },
// 卡包券卡动态统计
  GET_STATISTICALBYCARDBAG (params) {
    return api.fetch('post', `${base}/getStatisticalByCardbag`, params)
  },
// 根据会员编号查询会员简单信息，主要用于查询券卡送礼人和收礼人简单信息
  GET_BASEMEMBERINFO (params) {
    return api.fetch('post', `${base}/getBaseMemberinfo`, params)
  },
// 卡券加入卡包接口，主要用于兑换礼券和充值卡
  GET_ADDCODETOCARDBAG (params) {
    return api.fetch('post', `${base}/addCodeToCardbag`, params)
  },
// 我的优惠券
  GET_COUPONOFCARDBAG (params) {
    return api.fetch('post', `${base}/getCouponOfCardbag`, params)
  },
// 卡包优惠券动态统计
  GET_STATISTICALBYCOUPONCARDBAG (params) {
    return api.fetch('post', `${base}/getStatisticalByCouponCardbag`, params)
  },
// 营销优惠券列表查询接口
  GET_COUPONPROMOTION (params) {
    return api.fetch('post', `${base}/getCouponpromotionList`, params)
  },
// 营销优惠券领取接口
  GET_ADDCOUPON (params) {
    return api.fetch('post', `${base}/addCoupon`, params)
  },
// 营销优惠券绑定
  GET_BINDCOUPON (params) {
    return api.fetch('post', `${base}/bindCoupon`, params)
  },
// 关注商品列表
  GET_ATTENTION_GOODS_LIST (params) {
    return api.fetch('post', `${base}/getAttentionGoodsList`, params)
  },
// 关注商品
  ATTENTION_CART_ITEM (params) {
    return api.fetch('post', `${base}/attentionCartItem`, params)
  },
// 取消关注商品
  CANCLE_ATTENTION_CART_ITEM (params) {
    return api.fetch('post', `${base}/cancleAttentionCartItem`, params)
  },
// 加入购物车
  ADD_CART_ITEM (params) {
    return api.fetch('post', `${base}/addCartItem`, params)
  },
// 获取购物车列表
  GET_SHOPPINGCART (params) {
    return api.fetch('post', `${base}/getShoppingCart`, params)
  },
// 从购物车获取结算信息
  GET_SETTLEMENTFORM (params) {
    return api.fetch('post', `${base}/getSettlementFromShoppingCart`, params)
  },
// 从购物车移除商品
  GET_REMOVECARTITEM (params) {
    return api.fetch('post', `${base}/removeCartItem`, params)
  },
// 变更购物车中商品购买数量
  GET_CHANGEQUANTITY (params) {
    return api.fetch('post', `${base}/changeQuantity`, params)
  },
// 变更购物车中商品的选中状态
  GET_SELECTCARTITEM (params) {
    return api.fetch('post', `${base}/selectCartItem`, params)
  },
  // 获取购物车中的商品数量
  GET_QUANTITYOFSHOPPINGCART (params) {
    return api.fetch('post', `${base}/getQuantityOfShoppingCart`, params)
  },
// 新增降价通知
  GET_ADDDOWNNOTICE (params) {
    return api.fetch('post', `${base}/addDownNotice`, params)
  },
// 订单
// 订单提交
  GET_ADDORDERINFO (params) {
    return api.fetch('post', `${base}/addOrderinfo`, params)
  },
// 获取订单付款信息，包括付款信息初始化和校验付款结果
  GET_ORDERPAYINFO (params) {
    return api.fetch('post', `${base}/getOrderpayinfo`, params)
  },
// 获取微信付款码URL
  GETWXPAYURL (params) {
    return api.fetch('post', `${base}/getWxPayUrl`, params)
  },
// 订单状态归类统计
  GET_STATISTICALBYORDERSTATE (params) {
    return api.fetch('post', `${base}/getStatisticalByOrderstate`, params)
  },
// 我的订单列表数据接口
  GET_ORDERINFOLIST (params) {
    return api.fetch('post', `${base}/getOrderinfoList`, params)
  },
// 订单详情基础数据接口，包含订单基本信息、收货人信息，如果是预约自提订单，还包含预约自提门店信息
  GET_ORDERINFOBASEDET (params) {
    return api.fetch('post', `${base}/getOrderinfoBaseDet`, params)
  },
// 订单详情商品清单数据接口
  GET_ORDERINFOGOODSDET (params) {
    return api.fetch('post', `${base}/getOrderinfoGoodsDet`, params)
  },
// 订单配送信息数据接口
  GET_ORDERINFOEXPDET (params) {
    return api.fetch('post', `${base}/getOrderinfoExpDet`, params)
  },
// 订单付款信息数据接口
  GET_ORDERINFOPAYDET (params) {
    return api.fetch('post', `${base}/getOrderinfoPayDet`, params)
  },
// 订单开票信息数据接口
  GET_ORDERINFOINVOICEDET (params) {
    return api.fetch('post', `${base}/getOrderinfoInvoiceDet`, params)
  },
// 订单参与营销活动数据接口
  GET_ORDERINFOPROMOTIONDET (params) {
    return api.fetch('post', `${base}/getOrderinfoPromotionDet`, params)
  },
// 订单取消
  GET_CANCELORDERINFO (params) {
    return api.fetch('post', `${base}/cancelOrderinfo`, params)
  },
// 券卡查询
  GET_QUERYCODEINFO (params) {
    return api.fetch('post', `${base}/queryCodeinfo`, params)
  },
  // 获取商品图片
  GET_SELGOODSPICLIST (params) {
    return api.fetch('post', `${base}/selGoodspicList`, params)
  },
  // 申请送货、预约自提调用该接口进行初始化
  GET_EXCHANGEINIT (params) {
    return api.fetch('post', `${base}/exchangeInit`, params)
  },
  // 申请送货/预约自提券卡验证接口
  GET_EXCHANGECHECKCODE (params) {
    return api.fetch('post', `${base}/exchangeCheckCode`, params)
  },
  // 删除已验证券卡接口
  GET_REMOVECHECKEDCARD (params) {
    return api.fetch('post', `${base}/removeCheckedCard`, params)
  },
  // 获取已验证券卡列表接口
  GET_SELEXCHANGEITEMS (params) {
    return api.fetch('post', `${base}/selExchangeItems`, params)
  },
  // 兑换提交的订单接口
  GET_SUBMITPRESELLORDER (params) {
    return api.fetch('post', `${base}/submitPresellOrder`, params)
  },
  // 根据订单号查询关联券卡的剩余使用次数
   GET_SELRESIDUENUMBYORDERNO (params) {
    return api.fetch('post', `${base}/selResiduenumByOrderno`, params)
  },
  // 申请送货/预约自提选择商品提交接口
  GET_SUBCHOOSEGOODS (params) {
    return api.fetch('post', `${base}/subChooseGoods`, params)
  },
  // 更改商品初始化接口
  GET_UPDATECHOOSEGOODS (params) {
    return api.fetch('post', `${base}/updateChooseGoods`, params)
  },
  //获取活动地址信息
  GET_ACTIVITYURL (params) {
    return api.fetch('post', `${base}/initActUrl`, params)
  },
}



// WEBPACK FOOTER //
// ./src/apis/api.js